export default import.meta.ROLLDOWN_FILE_URL_ME_ORSWpfOZT8akIeCPVOQ